


<template>
    <!-- 表格列表里面的图片显示 -->
    <el-tooltip :placement="placement" effect="light">
            <div slot="content">
                <el-image :src="src" fit="cover"  :style="{'width':width+'px','line-height':height+'px','text-align':'center'}">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline" style="font-size:34px"></i>
                    </div>
                </el-image>
            </div>
            <div class="img-wrapper">
              <el-image :src="src"  fit="cover" style="width:150px;height:150px;line-height:150px">
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" style="font-size:26px"></i>
                </div>
              </el-image>
              <div class="img-edit" @click="handleRemove()">
                <i class="el-icon-delete"></i>
              </div>
            </div>
    </el-tooltip>
      
</template>

<script>

/**
* 
*     des: 表格里面显示图片插件；表格里面默认宽高70px   鼠标放大默认120px
*
*     width    : 鼠标放大图片宽度
*     height   : 鼠标放大图片高度
*     src      : 图片的路径
*     placement: 鼠标放大显示在表格图片上下左右   默认为右边
*
**/


export default {
  name:"TableImage",
  props:{
    width:{
      type:Number,
      default:120,
    },
    height:{
      type:Number,
      default:120,
    },
    src:{
      type:String,
      default:'',
    },
    placement: {
      type:String,
      default:'right',
    }
  },
  methods: {
    handleRemove(){
      this.$emit('handleRemove')
    }
  }
}
</script>

<style lang="less" scoped>
.image-slot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.el-image + .el-image {
  margin-left: 15px;
}
.img-wrapper{
  position: relative;
  margin-right:20px;
  &:hover {
    .img-edit {
        opacity: 1;
      }
  }
  .img-edit{
      position: absolute;
      top: 0;
      left: 0;
      width: 150px;
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0,0,0,0.5);
      opacity: 0;
      transition: opacity .3s;
      >i {
          font-size: 20px;
          color: #fff;
      }
  }
}
</style>
